import emptyCadastroBase from './emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'RF'
  },
  json: {
    cadastroUc: {
      idVinculoProcessoUc: null,
      informacoesAdministrativasUc: {
        cncu: null,
        nomeUc: null,
        esferaAdministrativa: null,
        objetivoCriacaoUc: null,
        orgaoGestor: null,
        categoriaManejo: null
      },
      numeroProcesso: null
    },
    qualificacao: null,
    cadastrante: {
      pessoa: null
    },
    interessado: {
      id: null,
      espolio: null,
      documentos: [],
      sociosRepresentantesLegais: [],
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            codigo: null,
            nome: null,
            estado: null
          },
          naturalidade: null,
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      },
      conjuge: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      }
    },
    imovel: {
      possuiCar: null,
      numeroReciboCar: null,
      documentos: [],
      denominacao: null,
      nomeImovelPropriedade: null,
      numeroTitulo: null,
      tempoOcupacao: null,
      ocupantesAnteriores: null,
      possuiImovel: null,
      conflitos: null,
      causasImpossibilidadeOcupacao: null,
      numeroProcessoJudicial: null,
      numeroMatricula: null,
      averbacaoTransferenciaDominio: null,
      averbacaoGeorreferenciamento: null,
      cnsMatricula: null,
      sncr: null,
      nirf: null
    },
    avaliacaoImovel: {
      vtn: null,
      valorBenfeitoriasReprodutivas: null,
      valorBenfeitoriasNaoReprodutivas: null,
      intimacaoValores: null,
      contraPropostas: null,
      cauArt: null,
      documentosLaudo: []
    },
    georreferenciamento: {
      localizacoes: [],
      documentos: [],
      denominacao: '',
      possuiGeorreferenciamento: '',
      responsavel: {
        nome: '',
        codigoIncra: '',
        creaRnp: '',
        formacao: '',
        codigoCredenciamento: '',
        matricula: ''
      }
    },
    cadastroRf: {
      id: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/default/empty/emptyRf.js